import type { MeResponse, Permission } from "../api/types";

export function hasPermission(auth: MeResponse, permission: Permission): boolean {
  return auth.permissions.includes(permission);
}

export function hasAnyPermission(auth: MeResponse, permissions: Permission[]): boolean {
  return permissions.some((permission) => hasPermission(auth, permission));
}

// Roles to landing-page mapping:
//   - IC → /gumballs
//   - Admin / Dynasty / Judicious → /admin/people
//   - Execution → /gumballs (sees the non-IC empty state)
export function landingPath(auth: MeResponse): string {
  const role = auth.membership.role.toLowerCase();
  if (role === "admin" || role === "dynasty" || role === "judicious") {
    return "/admin/people";
  }
  return "/gumballs";
}

export const ADMIN_GUMBALL_PERMISSIONS: Permission[] = [
  "gumballs:coins:upload",
  "gumballs:balances:adjust",
  "gumballs:season:manage",
  "gumballs:ledger:view"
];

export function isAdminPanelUser(auth: MeResponse): boolean {
  return hasAnyPermission(auth, ADMIN_GUMBALL_PERMISSIONS);
}

export function isICRole(auth: MeResponse): boolean {
  return auth.membership.role.toLowerCase() === "ic";
}

export function isAdminRole(auth: MeResponse): boolean {
  return auth.membership.role.toLowerCase() === "admin";
}
